import { render, staticRenderFns } from "./NoticeCategorySelector.vue?vue&type=template&id=d6865f56&scoped=true&"
import script from "./NoticeCategorySelector.vue?vue&type=script&lang=ts&"
export * from "./NoticeCategorySelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6865f56",
  null
  
)

export default component.exports